import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form, Button, Radio,
  Input, Upload,
} from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import history from 'utils/history'

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 5,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
}

const tailLayout = {
  wrapperCol: {
    xs: {
      offset: 24,
      span: 24,
    },
    sm: {
      offset: 5,
      span: 12,
    },
  },
}

const FormCategory = ({
  handleSubmit, isEdit, isSubmit,
  handleUpload, imgFile, data,
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (isEdit && data) {
      form.setFieldsValue({
        name: data?.name || '',
        status: data?.status || false,
        description: data?.description || '',
      })
    }
  }, [data])

  const validateMessages = {
    required: "'${label}' wajib diisi!", // eslint-disable-line no-template-curly-in-string
  }

  return (
    <div>
      <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
        <h3 className="title-content mb-0">
          {isEdit ? 'Ubah' : 'Tambah'}
          {' '}
          Kategori
        </h3>
      </div>
      <Card className="pt-4">
        <Form
          {...formItemLayout}
          form={form}
          name="survey"
          onFinish={handleSubmit}
          validateMessages={validateMessages}
        >
          <Form.Item label="Nama" name="name" rules={[{ required: true }]}>
            <Input placeholder="Nama" />
          </Form.Item>

          <Form.Item label="Deskripsi Singkat" name="description" rules={[{ required: true }]}>
            <Input placeholder="Deskripsi singkat" />
          </Form.Item>

          <Form.Item
            name="logo_file"
            label="Ikon"
            valuePropName="logoFile"
            extra="Ukuran berkas maksimal 1 MB"
            getValueFromEvent={handleUpload}
          >
            <Upload
              showUploadList={false}
              beforeUpload={() => false}
            >
              <React.Fragment>
                {imgFile && (
                  <img src={imgFile} className="icon-thumbnail-form" alt="Ikon Kategori" />
                )}
                <div>
                  <Button icon={<UploadOutlined />}>Klik untuk unggah</Button>
                </div>
              </React.Fragment>
            </Upload>
          </Form.Item>

          <Form.Item name="status" label="Status" rules={[{ required: true }]} initialValue="inactive">
            <Radio.Group>
              <Radio value="active">Aktif</Radio>
              <Radio value="inactive">Inaktif</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item {...tailLayout} className="btn-primary-wrapper text-right">
            <Button onClick={() => window.history.back()} className="m-r-10" style={{ display: 'inline-block' }}>Batal</Button>
            <Button type="primary" loading={isSubmit} htmlType="submit">{isEdit ? 'Kirim Perubahan' : 'Buat'}</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

FormCategory.propTypes = {
  handleSubmit: PropTypes.func,
  isSubmit: PropTypes.bool,
  isEdit: PropTypes.bool,
  handleUpload: PropTypes.func,
  imgFile: PropTypes.any,
  data: PropTypes.object,
}

export default FormCategory
